import { CategoryChartQueryFn, CategoryChartQueryParam } from "../categoryChart";
import { FigureKpiProviders } from "./categoryChartData.types";
import { getTariffStructureFigureData } from "./fetchFigureTariffStructureProviderChartData";

export const fetchFigureTariffStructureComparisonChartData: CategoryChartQueryFn = async ({
    categoryChart,
    providers
}: CategoryChartQueryParam): Promise<FigureKpiProviders> => {
    if (!providers || !providers?.length || !categoryChart) return null;
    const figureData = await getTariffStructureFigureData(providers);
    return figureData;
};
